var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9380_97401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6545 5.75H4.15454",
    stroke: "#991F27",
    strokeWidth: 1.5846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1548 10.25V16.25",
    stroke: "#991F27",
    strokeWidth: 1.5846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.655 10.25V16.25",
    stroke: "#991F27",
    strokeWidth: 1.5846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1548 5.75V20C19.1548 20.1989 19.0758 20.3897 18.9351 20.5303C18.7945 20.671 18.6037 20.75 18.4048 20.75H6.40479C6.20587 20.75 6.01511 20.671 5.87446 20.5303C5.7338 20.3897 5.65479 20.1989 5.65479 20V5.75",
    stroke: "#991F27",
    strokeWidth: 1.5846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1548 5.75V4.25C16.1548 3.85218 15.9967 3.47064 15.7154 3.18934C15.4341 2.90804 15.0526 2.75 14.6548 2.75H10.1548C9.75696 2.75 9.37543 2.90804 9.09413 3.18934C8.81282 3.47064 8.65479 3.85218 8.65479 4.25V5.75",
    stroke: "#991F27",
    strokeWidth: 1.5846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9380_97401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.404785 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.120ebf700b29f1fbea57fcc411cba94b.svg";
export { ForwardRef as ReactComponent };